import type { SingleSlate } from '../../game/domains/common/types/single.slate';

export const getPicksCount = (currentSingleSlate: SingleSlate) =>
  Math.min(currentSingleSlate?.expectedPicksCount ?? 0, currentSingleSlate?.gamesCount ?? 0) -
  (currentSingleSlate?.picks?.length ?? 0);
